import { z } from 'zod';

import { confirmationOfApplicationSchema } from '@/features/ui/Steps/ConfirmationOfApplication/model/schemas';

import {
  zodArrayRequiredWithMinMax,
  zodCheckbox,
  zodDate,
  zodEmailOptional,
  zodPhoneMissingPerson,
  zodSelectOption,
  zodStringOptionalWithMinMax,
  zodStringRequired,
  zodStringRequiredWithMinMax,
} from '@/shared/lib/validations';

import { FormConstants } from '@/components/Forms/constants';

import { applicantDocumentsDataSchemaRequired } from '@/modules/rmp/shared/model/schemas';

export const missingPersonInfoSchema = z.object({
  missingPerson: z.object({
    lastName: zodStringRequiredWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
    firstName: zodStringRequiredWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
    middleName: zodStringOptionalWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
    birthday: zodDate(),
    status: zodSelectOption,
    disappearance_document: z.any(),
  }),
});

export const applicantInfoBaseSchema = z.object({
  applicant: z.object({
    lastName: zodStringRequiredWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
    firstName: zodStringRequiredWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
    middleName: zodStringOptionalWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
    gender: zodSelectOption,
    email: zodEmailOptional,
    phones: zodArrayRequiredWithMinMax(zodPhoneMissingPerson, { max: 4 }),
    rnokpp: zodStringRequiredWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_10 }),
    resubmittingRequest: zodCheckbox,
    ancestralConnection: z.object(
      {
        id: zodStringRequired,
        label: zodStringRequired,
        required_documents: z.array(zodSelectOption),
      },
      { errorMap: () => ({ message: 'Необхідно заповнити поле' }) },
    ),
    documents: z.any(),
    additional_document: z.any(),
    additional_info: zodStringOptionalWithMinMax({ max: FormConstants.INPUT_MAX_LENGTH_255 }),
  }),
});

export const applicantInfoSchema = applicantInfoBaseSchema.superRefine((data, ctx) => {
  for (const [index] of (data.applicant.ancestralConnection.required_documents ?? []).entries()) {
    const document = data.applicant?.documents?.[index];
    const documentResult = applicantDocumentsDataSchemaRequired.safeParse(document);

    if (!documentResult.success) {
      documentResult.error.issues.forEach((issue) => {
        ctx.addIssue({
          ...issue,
          message: 'Файл обовʼязковий до завантаження',
          path: ['applicant', 'documents', index, '0', 'attachments'],
        });
      });
    }
  }
});

export const missingPersonExtractMergedSchema = missingPersonInfoSchema
  .merge(applicantInfoBaseSchema)
  .merge(confirmationOfApplicationSchema);
